// extracted by mini-css-extract-plugin
export const heromap = "N_cR";